// usePublicDoc.ts
// example:
// const { data, loading } = usePublicDoc('offer.html', lang);
import { useState, useEffect } from 'react';

export const usePublicDoc = (fileName: string, lang: string) => {
  const [data, setData] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const url = import.meta.env.VITE_PUBLIC_DOCS;
    setLoading(true);

    fetch(`${url}/${lang}/${fileName}`)
      .then(r => r.ok ? r : (lang !== 'en' ? fetch(`${url}/en/${fileName}`) : r))
      .then(r => {
        if (!r.ok) throw new Error(`Failed to load ${fileName}`);
        return r.text();
      })
      .then(text => {
        setData(text);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, [fileName, lang]);

  return { data, loading, error };
};